import CtxMenu from './main.js'

const install = function (Vue) {
  Vue.prototype.$ctxMenu = CtxMenu
}
window.VueContextMenu = {install}
export default {install}



// WEBPACK FOOTER //
// ./src/index.js